export const cerrarSolicitud = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body })
    };

    fetch(
      apiUrl + "/solicitud/cerrar",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al cerrar solicitud: ", err);
        reject(err);
      });
  });
};
import { ApiResponse } from '../../types';

const apiUrl: string = import.meta.env.VITE_ADMIN_URL;

export const getAll = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body })
    };

    fetch(
      apiUrl + "/solicitud/obtener",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al obtener empleados: ", err);
        reject(err);
      });
  });
};

export const sendAnswer = (token: string, body: any): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body })
    };

    fetch(
      apiUrl + "/solicitud/responder",
      requestOptions
    )
      .then((res) => res.json())
      .then((data: ApiResponse) => {
        resolve(data);
      })
      .catch((err) => {
        console.error("Error al responder solicitud: ", err);
        reject(err);
      });
  });
};
